import * as React from 'react';
import { FC, useState, Fragment } from 'react';
import {
    List, Datagrid,
    TextField, EditButton, BooleanField, NumberField,
    useNotify,useDelete,
    ListProps, Button as RAButton,
    useRecordContext
} from 'react-admin';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { ICategory } from '../types/types'; // Adjust the path as needed
import useAuthorize from '../hooks/useAuthorize';
import { UserRole } from '../types/types';
import { ALL_CATEGORIES_FILTER } from '../utils/materialTypeFilters';

const DeleteWithConfirmButton: FC = () => {
    const record = useRecordContext<ICategory>();
    const [deleteOne, { isLoading }] = useDelete();
    const [open, setOpen] = useState(false);
    const notify = useNotify();

    const handleDelete = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const confirmDelete = async () => {
        await deleteOne('categories', { id: record.id });
        notify('resources.categories.notification.deleted', {
            type: 'info',
            messageArgs: { smart_count: 1, name: 'Category' }
        });
        setOpen(false);
    };

    return (
        <Fragment>
            <RAButton
                label="Delete"
                onClick={handleDelete}
                startIcon={<DeleteIcon />}
                disabled={isLoading}
            />
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this category?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={confirmDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export const CategoryList: FC<ListProps> = (props) => {
    useAuthorize([UserRole.Admin]);
    return (
        <List {...props} filter={ALL_CATEGORIES_FILTER} filterDefaultValues={ALL_CATEGORIES_FILTER}>
            <Datagrid>
                <TextField source="category_name" label="Category Name" />
                <TextField source="category_description" label="Description" />
                <NumberField source="moq" label="MOQ (MT)" />
                <BooleanField source="is_virgin" label="Virgin" />
                <BooleanField source="is_reprocessed" label="Reprocessed" />
                <EditButton />
                <DeleteWithConfirmButton />
            </Datagrid>
        </List>
    );
};
